import Layout from '@/layout'

const route = {
  path: '/releaseGroup',
  component: Layout,
  redirect: '/releaseGroup/index',
  alwaysShow: true, // will always show the root menu
  name: 'releaseGroup',
  meta: {
    title: '投放报表',
    icon: 'dataReport',
    roles: [
      'release_report.management'
    ]
  },
  children: [
    // 图表分析
    {
      path: '/releaseGroupList/index',
      component: () => import('@/views/releaseGroupList/index.vue'),
      name: 'releaseGroupList',
      meta: {
        title: '投放组列表',
        icon: 'component',
        roles: [
          'release_group.index'
        ]
      }
    },
    {
      path: '/operations/index',
      component: () => import('@/views/operations/index.vue'),
      name: 'operations',
      meta: {
        title: '运营组列表',
        icon: 'component',
        roles: [
          'operation_group.index'
        ]
      }
    },
    {
      path: '/bookOwnership/index',
      component: () => import('@/views/bookOwnership/index.vue'),
      name: 'bookOwnership',
      meta: {
        title: '书籍归属列表',
        icon: 'component',
        roles: [
          'release_report.belong_list'
        ]
      }
    },
    {
      path: '/dropLocationList/index',
      component: () => import('@/views/dropLocationList/index.vue'),
      name: 'dropLocationList',
      meta: {
        title: '投放位置列表',
        icon: 'component',
        roles: [
          'positions.index'
        ]
      }
    },
    {
      path: '/bindingRelationList/index',
      component: () => import('@/views/bindingRelationList/index.vue'),
      name: 'bindingRelationList',
      meta: {
        title: '绑定关系列表',
        icon: 'component',
        roles: [
          'bind_wechat.index'
        ]
      }
    }, {
      path: '/reportList/index',
      component: () => import('@/views/reportList/index.vue'),
      name: 'reportList',
      meta: {
        title: '报表列表',
        icon: 'component',
        roles: [
          'release_report.bind_wechat_report'
        ]
      }
    }, {
      path: '/totalReportList/index',
      component: () => import('@/views/totalReportList/index.vue'),
      name: 'totalReportList',
      meta: {
        title: '总计报表',
        icon: 'component',
        roles: [
          'release_report.bind_wechat_total_report'
        ]
      }
    }, {
      path: '/totalReportListV2/index',
      component: () => import('@/views/totalReportListV2/index.vue'),
      name: 'totalReportListV2',
      meta: {
        title: '总计报表V2',
        icon: 'component',
        roles: [
          'release_report.bind_wechat_total_report_v2'
        ]
      }
    }, {
      path: '/reportForm/index',
      component: () => import('@/views/reportForm/index.vue'),
      name: 'reportForm',
      meta: {
        title: 'T图列表',
        icon: 'component',
        roles: [
          'release_report.bind_wechat_t_report'
        ]
      }
    },
    {
      path: '/threShold/index',
      component: () => import('@/views/threShold/index.vue'),
      name: 'threShold',
      meta: {
        title: '阈值列表',
        icon: 'component',
        roles: [
          'bind_threshold_configs.index'
        ]
      }
    }
  ]
}

export default route
